import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import PageHeader from '../components/layout/PageHeader';
import PortableTextContent from '../components/ui/PortableTextContent';
import PageBlocks from '../components/pages/PageBlocks';
import sitePages from '../cms/site-pages.json';
import '../css/pages/SitePage.css';

/**
 * Renders a CMS Custom Page by slug (from /pages/:slug or a top-level short URL route).
 */
const SitePage = ({ pageSlug: pageSlugProp }) => {
  const { slug: slugParam } = useParams();
  const slug = pageSlugProp || slugParam;
  const page = sitePages.find((p) => p.slug === slug && p.enabled);

  if (!page) {
    return <Navigate to="/404" replace />;
  }

  const hasSections = Array.isArray(page.sections) && page.sections.length > 0;

  return (
    <div>
      <PageHeader title={page.title} subtitle={page.subtitle} />
      {hasSections ? (
        <PageBlocks sections={page.sections} />
      ) : (
        <div className="site-page-container">
          <PortableTextContent value={page.body} />
        </div>
      )}
    </div>
  );
};

export default SitePage;
